import { render, staticRenderFns } from "./GainPointsAll.vue?vue&type=template&id=8c81616a&scoped=true&"
import script from "./GainPointsAll.vue?vue&type=script&lang=js&"
export * from "./GainPointsAll.vue?vue&type=script&lang=js&"
import style0 from "./GainPointsAll.vue?vue&type=style&index=0&id=8c81616a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c81616a",
  null
  
)

export default component.exports